// Angular Core
import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// Interfaces
import { InterceptorError } from '../../interfaces/InterceptErrors';
import { TokenConfigs } from '../../interfaces/TokenConfigs';

// Services
import { TokenService } from '../../services/token/token.service';

// RxJS
import { catchError, switchMap, throwError } from 'rxjs';

const MAX_RETRIES = 3;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Dependency Injections
  const tokenService: TokenService = inject(TokenService);
  const router: Router = inject(Router);

  const publicUrls: string[] = [
    '/auth/login',
    '/password/forgot',
    'viacep.com.br/ws/',
  ];

  const messagesToCheck: string[] = [
    'O Token esta expirado, por favor, realizar login novamente.',
    'O Token esta invalido, por favor, relizar login novamente.',
    'O Token nao foi encontrado, por favor, verificar e tentar realizar a operacao novamente.',
  ];

  const isPublicRequest: boolean = publicUrls.some((url) =>
    req.url.includes(url)
  );

  let authReq: HttpRequest<unknown> = req;

  if (!isPublicRequest) {
    let token: string = '';

    if (req.url.includes('/refresh')) {
      token = tokenService.getToken()?.token;
    }

    token = tokenService.getToken()?.token;
    if (token) {
      authReq = req.clone({ setHeaders: { Authorization: token } });
    }
  }

  return next(authReq).pipe(
    catchError((errorResponse: HttpErrorResponse) => {
      if (
        errorResponse.status === 401 &&
        messagesToCheck.includes(errorResponse.error.error)
      ) {
        if (tokenService.refreshAttempts >= MAX_RETRIES) {
          tokenService.resetRefreshAttempts();
          return throwError((): InterceptorError => {
            router.navigate(['/login']);
            return {
              errorType: 'refreshTokenError',
              error: {
                error: 'Sessão expirada, realize o login novamente.',
                code: 'I401',
              },
            };
          });
        }

        tokenService.incrementRefreshAttempts();

        return tokenService.refreshToken().pipe(
          switchMap((newToken: TokenConfigs) => {
            const newAuthReq = req.clone({
              setHeaders: { Authorization: newToken.access_token },
            });

            return next(newAuthReq);
          }),
          catchError((refreshError: HttpErrorResponse) => {
            tokenService.resetRefreshAttempts();
            return throwError((): InterceptorError => {
              router.navigate(['/login']);
              return {
                errorType: 'refreshTokenError',
                error: {
                  error: 'Sessão expirada, realize o login novamente.',
                  code: 'I401',
                },
              };
            });
          })
        );
      }

      return throwError(() => errorResponse);
    })
  );
};
